import(/* webpackMode: "eager" */ "/opt/sophia-shopper/landing/components/AuthenticityScanner.tsx");
;
import(/* webpackMode: "eager" */ "/opt/sophia-shopper/landing/components/CTA.tsx");
;
import(/* webpackMode: "eager" */ "/opt/sophia-shopper/landing/components/FAQ.tsx");
;
import(/* webpackMode: "eager" */ "/opt/sophia-shopper/landing/components/Features.tsx");
;
import(/* webpackMode: "eager" */ "/opt/sophia-shopper/landing/components/Footer.tsx");
;
import(/* webpackMode: "eager" */ "/opt/sophia-shopper/landing/components/HowItWorks.tsx");
;
import(/* webpackMode: "eager" */ "/opt/sophia-shopper/landing/components/InvestmentCalc.tsx");
;
import(/* webpackMode: "eager" */ "/opt/sophia-shopper/landing/components/LiveDemo.tsx");
;
import(/* webpackMode: "eager" */ "/opt/sophia-shopper/landing/components/MobileAppTeaser.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileHero"] */ "/opt/sophia-shopper/landing/components/MobileHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Nav"] */ "/opt/sophia-shopper/landing/components/Nav.tsx");
;
import(/* webpackMode: "eager" */ "/opt/sophia-shopper/landing/components/Newsletter.tsx");
;
import(/* webpackMode: "eager" */ "/opt/sophia-shopper/landing/components/PortfolioTracker.tsx");
;
import(/* webpackMode: "eager" */ "/opt/sophia-shopper/landing/components/PortfolioVisualizer.tsx");
;
import(/* webpackMode: "eager" */ "/opt/sophia-shopper/landing/components/PriceDropAlerts.tsx");
;
import(/* webpackMode: "eager" */ "/opt/sophia-shopper/landing/components/ResaleValue.tsx");
;
import(/* webpackMode: "eager" */ "/opt/sophia-shopper/landing/components/Retailers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollPinnedHero"] */ "/opt/sophia-shopper/landing/components/ScrollPinnedHero.tsx");
;
import(/* webpackMode: "eager" */ "/opt/sophia-shopper/landing/components/SocialProof.tsx");
;
import(/* webpackMode: "eager" */ "/opt/sophia-shopper/landing/components/TrendingBrands.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrustStrip"] */ "/opt/sophia-shopper/landing/components/TrustStrip.tsx");
;
import(/* webpackMode: "eager" */ "/opt/sophia-shopper/node_modules/.pnpm/next@15.5.15_@babel+core@7.29.0_@opentelemetry+api@1.9.1_@playwright+test@1.59.1_react-dom@18_75rbgrgof4only63ypsqe3ogku/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/opt/sophia-shopper/node_modules/.pnpm/next@15.5.15_@babel+core@7.29.0_@opentelemetry+api@1.9.1_@playwright+test@1.59.1_react-dom@18_75rbgrgof4only63ypsqe3ogku/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
